<template>
	<div id="paxExpress">
		<div v-if="!addOrEditReady">
			<LoadingSpinner class="col-12" />
		</div>
		<div v-else>
			<div v-if="criteres_local.length > 2 && Object.keys(recap).length > 0" class="row">
				<div class="d-none d-lg-block d-xl-block">
					<button href="#" @click="goBack()" class="btn btn-primary btn-prev mb-2"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /> {{ $t('pax.retour') }}</button>
				</div>
				<div class="col">
					<div class="row no-gutters align-items-center mb-3">
						<div class="col col-lg-12">
							<a href="#" @click="goBack()" class="btn btn-primary btn-retour mb-3 d-lg-none"><font-awesome-icon :icon="['fal', 'long-arrow-left']" /> {{ $t('pax.retour') }}</a>
						</div>
					</div>
					<div class="row ml-1 mb-2">
						<h3 class="mb-0 mb-lg-3">4. {{ $t('pax.comparaison') }}</h3>
						<div v-if="pax_express" class="col-auto">
							<div class="input-group stallion_search">
							    <button class="input-group-text px-3" @click="openIntroduction"><font-awesome-icon :icon="['fas', 'info']" /></button>
							</div>
						</div>
						<div class="synthese w-100"><i>{{ $t('pax.comparaison_text') }}</i></div>
					</div>
					<div class="row align-items-center mb-3">
						<div class="col-lg-3 d-none d-lg-block"></div>
						<div :class="'col-'+col_stallion+' text-center stallion '+ getGlobalColor(callColorGrade(stallion.horse_id), colorGeneticIndicator(stallion.horse_id))" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<span class="stallion-pill">{{ stallion.horse_nom }}</span>
						</div>
					</div>
					<hr>
					<div class="row align-items-center synthese">
						<div class="col mb-2">
							<h4>{{ $t('pax.predisposition_title') }} <font-awesome-icon v-b-toggle="'collapse-text-genetic'" class="d-lg-none" :icon="['far', 'info-circle']" /></h4>
							<i class="d-lg-inline d-none">{{ predisposition_text }}</i>
							<b-collapse class="d-lg-none" :ref="'collapse-text-genetic'" :id="'collapse-text-genetic'">
								<i>{{ predisposition_text }}</i>
							</b-collapse>
						</div>
					</div>
					<div class="row align-items-center">
						<div class="col-lg-3 d-none d-lg-flex align-items-center justify-content-center">
							<span v-b-toggle="'collapse-genetic'" class="cursor-pointer text-primary small">{{ $t('pax.plus_dinfo') }}</span>
							<font-awesome-icon v-b-toggle="'collapse-genetic'" :icon="['fal', 'angle-right']" class="ml-1 small" />
						</div>
						<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<div v-b-toggle="'collapse-genetic'" :class="colorGeneticIndicator(stallion.horse_id)+' stallion cursor-pointer'">
								<div class="stallion-icon"><font-awesome-icon :icon="['fal', 'venus-mars']"/></div>
							</div>
							<b-collapse :ref="'collapse-genetic'" :id="'collapse-genetic'">
								{{ $t('pax.blup_mere') }} : {{ blupFormattedStallion(stallion.horse_id) }} <br>
								{{ $t('pax.blup_pere') }} : {{ blupFormattedMare(stallion.horse_id) }}
							</b-collapse>
						</div>
						<div v-b-toggle="'collapse-genetic'" class="d-lg-none col-12 mt-1 text-center">
							<span class="cursor-pointer text-primary">{{ $t('pax.plus_dinfo') }}</span>
						</div>
					</div>
					<hr>
					<div class="row align-items-center synthese">
						<div class="col mb-2">
							<h4>{{ $t('pax.comptabilite_title') }} <font-awesome-icon v-b-toggle="'collapse-text-compatibilite'" class="d-lg-none" :icon="['far', 'info-circle']" /></h4>
							<i class="d-lg-inline d-none">{{ $t('pax.comptabilite_text') }}</i>
							<b-collapse class="d-lg-none" :ref="'collapse-text-compatibilite'" :id="'collapse-text-compatibilite'">
								<i>{{ $t('pax.comptabilite_text') }}</i>
							</b-collapse>
						</div>
					</div>
					<div class="row align-items-center">
						<div class="col-lg-3 d-none d-lg-flex align-items-center justify-content-center">
							<span v-b-toggle="'collapse-compatibilite'" class="cursor-pointer text-primary small">{{ $t('pax.detail_ici') }}</span>
							<font-awesome-icon v-b-toggle="'collapse-compatibilite'" :icon="['fal', 'angle-right']" class="ml-1 small" />
						</div>
						<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<div :class="callColorGrade(stallion.horse_id)+' stallion cursor-pointer'" v-b-toggle="'collapse-compatibilite'">
								<div class="stallion-icon"><font-awesome-icon :icon="['fal', 'puzzle']"/></div>
							</div>
						</div>
						<div v-b-toggle="'collapse-compatibilite'" class="d-lg-none col-12 mt-1 text-center">
							<span class="cursor-pointer text-primary">{{ $t('pax.detail_ici') }}</span>
						</div>
					</div>
					<hr>
					<b-collapse :ref="'collapse-compatibilite'" :id="'collapse-compatibilite'">
						<div class="tabLine" v-for="critere in criteres_local" :key="critere.criteres_id">
							<div class="row no-gutters align-items-center">
								<div class="col-lg-3 col-12">
									{{ critere.critereslang_label }}
								</div>
								<div :class="'col-'+col_stallion+' text-center'" v-for="stallion in stallions_local" :key="stallion.horse_id">
									<span class="bullet red" v-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) < critere.criteres_red" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet green" v-else-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) >= critere.criteres_green" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet orange" v-else-if="parseInt(recap[stallion.horse_id][critere.criteres_id]) >= critere.criteres_red && parseInt(recap[stallion.horse_id][critere.criteres_id]) < critere.criteres_green" @click.prevent="openModalGraphique(critere, stallion.horse_id)" role="button">
									</span>
									<span class="bullet grey" v-else></span>
								</div>
							</div>
						</div>
					</b-collapse>
					<div class="row no-gutters align-items-center my-3">
						<div class="col-lg-3 d-none d-lg-block"></div>
						<div :class="'col-'+col_stallion+' text-center px-1'" v-for="stallion in stallions_local" :key="stallion.horse_id">
							<div class="row no-gutters tools mt-4 modal-pax justify-content-center">
								<template v-if="pax_express">
									<div class="col-12 mb-2 px-1">
										<a class="modal-btn" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + stallion.horse_nom + '&horse_sire=' + stallion.horse_sire " target="_blank"><span><i>{{stallion.horse_nom}}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
									</div>
									<div class="col-12 px-1">
										<a class="modal-btn" target="_blank" href="https://clients.gfeweb.com/"><span><font-awesome-icon :icon="['far', 'money-check-edit']" /> <b>{{ $t('pax.reserver_en_ligne') }}</b></span></a>
									</div>
								</template>
								<template v-else>

									<div class="col-12 py-1">
										<a class="modal-btn light" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + stallion.horse_nom + '&horse_sire=' + stallion.horse_sire " target="_blank"><span><i>{{ stallion.horse_nom }}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
									</div>
									<div class="col-12 py-1 mt-md-2 mt-xxl-0">
										<router-link :to="{ name: 'ContractNew', params: {stallion_id: stallion.horse_id, mare_id: mare.horse_id}}" target="_blank" class="modal-btn light"><span><b>{{ $t('pax.reserver_en_ligne') }}</b></span></router-link>
									</div>
									<div class="col-12 py-1 mt-md-2 mt-xxl-0">
										<a class="modal-btn light" href="#" v-if="reload_print" @click.prevent="submitPrint(stallion)">
											<span>
												<font-awesome-icon v-if="stallion.processing_print" :icon="['fas', 'spinner']" pulse />
												<b>{{ $t('pax.simulation_croisement') }}</b>
											</span>
										</a>
									</div>
								</template>
							</div>

						</div>
					</div>
					<div id="newAccount" v-if="pax_express && !isLg && !isXl">
						<h3>{{ $t('pax.creer_compte_pour') }} :</h3>
						<ul>
							<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.comparer_dix_etalons') }}</li>
							<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.obtenir_predisposition_genetique') }}</li>
							<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.voir_recommandation_pax') }}</li>
							<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.save_votre_jument') }}</li>
						</ul>
						<p></p>
						<a href="https://clients.gfeweb.com/" class="btn btn-white">{{ $t('pax.se_connecter') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></a>
					</div>
				</div>
				<div id="newAccount" class="col-lg-3 news_accountLG" v-if="pax_express && (isLg || isXl)">
					<h3 class="mt-lg-4 mb-lg-3">{{ $t('pax.creer_compte_pour') }} :</h3>
					<ul>
						<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.comparer_dix_etalons') }}</li>
						<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.obtenir_predisposition_genetique') }}</li>
						<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.voir_recommandation_pax') }}</li>
						<li><font-awesome-icon :icon="['fas', 'caret-right']"/> {{ $t('pax.save_votre_jument') }}</li>
					</ul>
					<a href="https://clients.gfeweb.com/" class="btn btn-white">{{ $t('pax.se_connecter') }} <font-awesome-icon :icon="['fal', 'long-arrow-right']" /></a>
				</div>

				<b-modal dialog-class="modal-pax" ref="modalChoix" hide-footer>
					<template v-slot:modal-title class="d-flex">
						{{ $t('pax.detail_croisement') }}
						<button class="input-group-text px-3 modal-header-btn" v-if="pax_express" @click="openIntroduction"><font-awesome-icon :icon="['fas', 'info']" /></button>
						<template v-if="!pax_express">
							<span class="elipsis">{{ stallion_nom }} X {{ mare.horse_nom }}</span>
						</template>
					</template>

					<template v-if="stallion_choose != null">
						<div class="tabLine" v-for="critere in criteres_local" :key="critere.criteres_id">
							<div class="row no-gutters align-items-center" >
								<div class="col-6">
									{{ critere.critereslang_label }}
								</div>
								<div class="col text-center">
									<span class="bullet red" v-if="parseInt(recap[stallion_choose][critere.criteres_id]) < critere.criteres_red">
									</span>
									<span class="bullet green" v-else-if="parseInt(recap[stallion_choose][critere.criteres_id]) >= critere.criteres_green">
									</span>
									<span class="bullet orange" v-else-if="parseInt(recap[stallion_choose][critere.criteres_id]) >= critere.criteres_red && parseInt(recap[stallion_choose][critere.criteres_id]) < critere.criteres_green">
									</span>
									<span class="bullet grey" v-else></span>
								</div>
							</div>
						</div>

						<div class="row no-gutters tools mt-4">
							<template v-if="pax_express">
								<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12 px-1">
									<a class="modal-btn" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + stallion_nom + '&horse_sire=' + stallion_sire " target="_blank"><span><i>{{ stallion_nom }}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
								</div>
								<div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12  mt-3 mt-md-0 px-1">
									<a class="modal-btn" href="https://clients.gfeweb.com/" target="_blank"><span><font-awesome-icon :icon="['far', 'money-check-edit']" /> <b>{{ $t('pax.reserver_en_ligne') }}</b></span></a>
								</div>
							</template>
							<template v-else>
								<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1">
									<router-link :to="{ name: 'ContractNew', params: {stallion_id: stallion_choose, mare_id: mare.horse_id}}" target="_blank" class="modal-btn"><span><font-awesome-icon :icon="['far', 'money-check-edit']" /><b>{{ $t('pax.reserver_en_ligne') }}</b></span></router-link>
								</div>
								<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1 mt-3 mt-md-0">
									<a class="modal-btn" href="#" @click.prevent="goToPaxGraphique(stallion_choose)"><span><font-awesome-icon :icon="['far', 'chart-area']" /> <b>{{ $t('pax.go_to_pax_graphique') }}</b></span></a>
								</div>

								<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1 mt-3 mt-md-0">
									<a class="modal-btn" :href="'https://www.gfeweb.com/' + lang + '/?redirect_to_fiche=1&horse_nom=' + stallion_nom + '&horse_sire=' + stallion_sire " target="_blank"><span><i>{{ stallion_nom }}</i><b>{{ $t('pax.voir_fiche_etalon') }}</b></span></a>
								</div>
								<div class="col-xxl-4 col-xl-6 col-lg-4 col-md-4 col-12 px-1 mt-3 mt-md-0" v-if="stallion_choose_obj">
									<a class="modal-btn" href="#" v-if="reload_print" @click.prevent="submitPrint(stallion_choose_obj)"><span>
										<font-awesome-icon v-if="stallion_choose_obj.processing_print" :icon="['fas', 'spinner']" pulse />
										<font-awesome-icon v-else :icon="['far', 'file-pdf']" />
										<b>{{ $t('pax.simulation_croisement') }}</b>
									</span></a>
								</div>
							</template>
						</div>
					</template>
				</b-modal>


			</div>
			<template v-else> 
				<p>{{ $t('pax.completer_criteres_voir_compatibilite') }}</p>
			</template>

			<b-modal dialog-class="modal-pax" ref="modal" hide-footer>
				<template v-slot:modal-title>
					<template v-if="pax_express">{{ $t('pax.pax_express') }}</template>
					<template v-else>{{ $t('pax.pax') }}</template>
				</template>

				<div v-html="text_intro"></div>
			</b-modal>

			<b-modal dialog-class="modal-pax" ref="modal-graphique" size="lg" hide-footer>
				<template v-if="critere" v-slot:modal-title>
					{{ critere.criteres_lang[0].critereslang_label }} - {{ graphique_jument.nom }} & {{ critere.stallion_name }}
				</template>

				<div v-if="critere" class="critere paxgraphique" id="myGroup">
					<div class="position-relative">
						<div class="pax-courbe position-relative">
							<!-- Img courbe -->
							<img :src="require(`/src/assets/img/pax/legende${(critere.caracterisations.stallion + critere.caracterisations.mare) / 2}.jpg`)" :alt="'min_max_' + critere.criteres_min + '_' + critere.criteres_max">
							<!-- Img carré vert -->
							<img :src="require(`/src/assets/img/pax/zone${critere.criteres_min}${critere.criteres_max}.png`)">

							<!-- Repères des caractérisations sur l'axe des abscisses -->
							<span class="pax-repere etalon" :style="{ left: getPaxAbscisse(critere.caracterisations.stallion) }"></span>
							<span class="pax-repere jument" :style="{ left: getPaxAbscisse(critere.caracterisations.mare) }"></span>
						</div>

						<div class="row">
							<div class="col critere_lang">{{ critere.criteres_lang[0].critereslang_moins }} </div>
							<div class="col text-right critere_lang">{{ critere.criteres_lang[0].critereslang_plus }}</div>
						</div>
					</div>
					<div class="pax-repere-legende">
						<span class="etalon">{{ graphique_etalon.nom }} : {{ graphique_etalon.valeur / 100 }}</span>
						<span class="jument">{{ graphique_jument.nom }} : {{ graphique_jument.valeur / 100 }}</span>
					</div>
					<span v-html="$t('pax.pax_graphique_modal_text')"></span>
				</div>
			</b-modal>
		</div>
	</div>
</template>

<script type="text/javascript">
	import Vue from 'vue'
	import Navigation from "@/mixins/Navigation.js"
	import PaxMixin from "@/mixins/Pax.js"
	import Tools from "@/mixins/Tools.js";
	import Window from '@/mixins/Window.js'
	import _cloneDeep from 'lodash/cloneDeep';

	export default {
		name: "ResultCompatibiliteV",
		props: {
			criteres: {
				type: Array,
				default: () => ( [] )
			},
			stallions: {
				type: Array,
				default: () => ( [] )
			},
			/** Mode PAX Express (accès public sans compte, fonctionnalités réduites) */
			pax_express: {
				type: Boolean,
				default: () => false
			},
			mare: {
				type: Object,
				default: () => ( null )
			},
			/** Déclenche le scroll vers le composant lorsque passé à true */
			show: {
				type: Boolean,
				default: () => false
			}
		},
		mixins: [Navigation, PaxMixin, Tools, Window],
		data () {
			return {
				addOrEditReady: false,
				stallions_local: [],
				criteres_local: [],
				lang: 'fr',
				stallion_choose: null,
				stallion_nom: null,
				stallion_sire: null, 
				recap: {},
				text_intro: '',
				graphique_etalon: null,
				graphique_jument: null,
				reload_print: true,
				genetic_indicators: [],
				genetic_loading: false,
				compat_loading: false,
				critere: null
			}
		},
		created() {
			this.init_component()
		},
		methods: {
			/**
			 * Initialise le composant : résout le texte d'introduction, déduplique les étalons
			 * et déclenche le calcul de compatibilité PAX.
			 */
			async init_component() {
				this.text_intro = this.getConfig('translations')['pax_introduction'][Vue.i18n.locale()]
				if(this.pax_express) {
					this.text_intro = this.getConfig('translations')['pax_express'][Vue.i18n.locale()]
				}
				this.addOrEditReady = false
				const stallions_local = _cloneDeep(this.stallions.filter(st => st))
				const unique = [...new Map(stallions_local.map(st => [st.horse_id, st])).values()]
				this.stallions_local = unique.map(st => ({...st, processing_print: false}))
				this.criteres_local = _cloneDeep(this.criteres)

				this.calculCompatibilite()
				this.calculGeneticIndicator()

				this.lang = this.getConfig('lang')

				this.addOrEditReady = true
			},

			/**
			 * Calcule les scores de compatibilité pour tous les étalons et critères sélectionnés.
			 * Met à jour `this.recap` avec les résultats indexés par [horse_id][criteres_id].
			 */
			async calculCompatibilite() {
				this.compat_loading = true
				this.recap = await this.paxCalculCompatiblite(this.stallions_local, this.criteres_local)
				this.compat_loading = false
			},

			/**
			 * Affiche la modale de détail du croisement pour un étalon donné.
			 * @param {number} stallion_id - Identifiant de l'étalon sélectionné
			 * @param {string} stallion_nom - Nom de l'étalon
			 * @param {string} stallion_sire - Code SIRE de l'étalon
			 */
			async displayDetailsCroisement(stallion_id, stallion_nom, stallion_sire) {
				this.stallion_choose = stallion_id
				this.stallion_nom = stallion_nom
				this.stallion_sire = stallion_sire
				this.$refs["modalChoix"].show()
			},

			/**
			 * Émet un événement pour revenir à l'étape de sélection de la jument (`mare_list`).
			 */
			async goBack() {
				this.$emit("update:step_label", "mare_list")
			},

			/**
			 * Ferme la modale de choix et navigue vers la vue graphique PAX pour l'étalon donné.
			 * @param {number} stallion_id - Identifiant de l'étalon
			 */
			goToPaxGraphique(stallion_id) {
				this.$refs["modalChoix"].hide()
				this.$emit("update:stallion_id", stallion_id)
				this.$emit('update:step_label', "pax_graphique")
			},

			/**
			 * Ferme la modale de choix et ouvre la modale d'introduction PAX (ou PAX Express).
			 */
			openIntroduction() {
				this.$refs["modalChoix"].hide()
				this.$refs["modal"].show()
			},

			/**
			 * Déclenche l'impression de la simulation de croisement pour un étalon.
			 * @param {Object} stallion - Objet étalon contenant au moins `horse_id`
			 */
			async submitPrint(stallion) {
				this.setProcessingPrint(stallion.horse_id, true)
				await this.printSimulationCroisement(this.mare, stallion)
				this.setProcessingPrint(stallion.horse_id, false)
			},

			/**
			 * Met à jour l'état `processing_print` d'un étalon pour l'affichage du spinner d'impression.
			 * Utilise un cycle `reload_print` pour forcer le re-render du composant.
			 * @param {number} stallion_id - Identifiant de l'étalon
			 * @param {boolean} value - `true` pour activer le spinner, `false` pour le désactiver
			 */
			setProcessingPrint(stallion_id, value) {
				const index = this.stallions_local.findIndex(st => st.horse_id == stallion_id)
				this.reload_print = false
				this.stallions_local[index].processing_print = value
				this.$nextTick(() => {
					this.reload_print = true
				})
			},

			/**
			 * Retourne la classe CSS de couleur de grade de compatibilité pour un étalon.
			 * @param {number} stallion_id - Identifiant de l'étalon
			 * @returns {string} Classe CSS de couleur (ex : 'green', 'orange', 'red')
			 */
			callColorGrade(stallion_id) {
				if(this.compat_loading) return 'genetic-loading'
				return this.colorGrade(stallion_id, this.recap, this.criteres_local)
			},

			/**
			 * Calcule et charge les indicateurs génétiques BLUP pour la jument et les étalons sélectionnés.
			 * Met à jour `this.genetic_indicators` avec les résultats indexés par `horse_id`.
			 */
			async calculGeneticIndicator() {
				const stallions_ids = this.stallions_local.map(stallion => stallion.horse_id)
				if(!this.mare || stallions_ids.length == 0) return false
				this.genetic_loading = true
				this.genetic_indicators = await this.getGeneticIndicator(this.mare.horse_id, stallions_ids.join(','))
				this.genetic_loading = false
			},

			/**
			 * Retourne la classe CSS de couleur de l'indicateur génétique pour un étalon.
			 * @param {number} stallion_id - Identifiant de l'étalon
			 * @returns {string} Classe CSS de couleur ou chaîne vide si l'indicateur est absent
			 */
			colorGeneticIndicator(stallion_id) {
				if(this.genetic_loading) return 'genetic-loading'
				return Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id].genetic_indicator_color : ''
			},

			/**
			 * Formate la valeur BLUP de l'étalon pour un indicateur génétique donné.
			 * @param {number} stallion_id - Identifiant de l'étalon
			 * @returns {string} Valeur BLUP formatée "valeur (code)" ou "N/A" si absente
			 */
			blupFormattedStallion(stallion_id) {
				const indicator = Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id] : null
				if(indicator && indicator.stallion_blup_value) {
					return `${indicator.stallion_blup_value} (${indicator.stallion_blup_cd})`
				}
				return 'N/A'
			},

			/**
			 * Formate la valeur BLUP de la jument pour un indicateur génétique donné.
			 * @param {number} stallion_id - Identifiant de l'étalon (clé de l'indicateur génétique)
			 * @returns {string} Valeur BLUP formatée "valeur (code)" ou "N/A" si absente
			 */
			blupFormattedMare(stallion_id) {
				const indicator = Object.prototype.hasOwnProperty.call(this.genetic_indicators, stallion_id) ? this.genetic_indicators[stallion_id] : null
				if(indicator && indicator.mare_blup_value) {
					return `${indicator.mare_blup_value} (${indicator.mare_blup_cd})`
				}
				return 'N/A'
			},

			/**
			 * Ouvre la modale graphique PAX pour un critère et un étalon donnés.
			 * Calcule les caractérisations (% étalon, % jument) et les attache au critère.
			 * @param {Object} critere - Objet critère contenant `criteres_id`, seuils et libellés
			 * @param {number} stallion_id - Identifiant de l'étalon à afficher
			 */
			openModalGraphique(critere, stallion_id) {
				// Reset à null puis réaffectation au tick suivant pour forcer le re-render
				// du composant image qui dépend de `critere.caracterisations`
				this.critere = null
				const stallion = this.stallions_local.find(horse => horse.horse_id == stallion_id)
				const valeur_stallion = stallion.horse_criteres[critere.criteres_id] * 100
				const valeur_mare = parseFloat(this.criteres_local.find(cri => cri.criteres_id == critere.criteres_id).slider) * 100
				critere.caracterisations = {
					stallion: valeur_stallion,
					mare: valeur_mare
				}
				critere.stallion_name = stallion.horse_nom
				// en PAX Express l'utilisateur n'a pas de jument enregistrée : mare vaut null
				const mare_nom = this.mare ? this.mare.horse_nom : this.$t('pax.ma_jument')
				this.graphique_etalon = { nom: stallion.horse_nom, valeur: valeur_stallion }
				this.graphique_jument = { nom: mare_nom, valeur: valeur_mare }

				// détail chiffré du croisement, pour contrôler la courbe affichée
				console.log(`PAX — ${critere.critereslang_label} : ${stallion.horse_nom} X ${mare_nom}`, {
					etalon: { horse_id: stallion.horse_id, nom: stallion.horse_nom, valeur: valeur_stallion },
					jument: { horse_id: this.mare ? this.mare.horse_id : null, nom: mare_nom, valeur: valeur_mare },
					moyenne: (valeur_stallion + valeur_mare) / 2,
					compatibilite: this.recap[stallion_id] ? this.recap[stallion_id][critere.criteres_id] : null,
					critere: {
						criteres_id: critere.criteres_id,
						criteres_min: critere.criteres_min,
						criteres_max: critere.criteres_max,
						criteres_red: critere.criteres_red,
						criteres_green: critere.criteres_green
					}
				})

				this.$nextTick(() => {
					this.critere = critere
				})
				this.$refs["modal-graphique"].show()
			},
		},
		computed: {
			/**
			 * Explication de la prédisposition génétique. En PAX Express l'indicateur n'est pas
			 * calculé faute de jument enregistrée : on invite à créer un compte.
			 * @returns {String}
			 */
			predisposition_text() {
				return this.pax_express ? this.$t('pax.predisposition_text_express') : this.$t('pax.predisposition_text')
			},
			/**
			 * Calcule la largeur de colonne Bootstrap (1–12) à attribuer à chaque colonne d'étalon
			 * en fonction du nombre d'étalons, du mode PAX Express et de la taille d'écran.
			 * @returns {number}
			 */
			col_stallion() {
				const nb_stallions = this.stallions.length
				if(this.isLg || this.isXl) {
					if(nb_stallions == 1) return 9
					if(nb_stallions == 2) return 4
					if(this.pax_express) return 2
					return 3
				}
				if(nb_stallions == 1) return 12
				if(nb_stallions == 2) return 6
				if(this.pax_express) return 3
				return 4
			},
			/**
			 * Calcule la largeur de colonne vide pour le mode PAX Express avec un seul étalon.
			 * @returns {number}
			 */
			col_empty_stallion() {
				const nb_stallions = this.stallions.length
				if(nb_stallions == 1 && this.pax_express) return 2
				return 0
			},
			/**
			 * Retourne l'objet étalon réactif sélectionné dans la modale de détail du croisement.
			 * Réutilisé par le bouton d'impression pour piloter le spinner `processing_print`.
			 * @returns {Object|undefined}
			 */
			stallion_choose_obj() {
				return this.stallions_local.find(stallion => stallion.horse_id == this.stallion_choose)
			}
		},
		watch: {
			stallions(val) {
				const unique = [...new Map(_cloneDeep(val.filter(st => st)).map(st => [st.horse_id, st])).values()]
				this.stallions_local = unique.map(st => ({...st, processing_print: false}))
				this.recap = {}
				this.calculCompatibilite()
				this.calculGeneticIndicator()
			},
			'criteres': {
				deep: true,
				handler(val){
					this.criteres_local = _cloneDeep(val)
					this.recap = {}
					this.calculCompatibilite()
				}
			},
			show(val) {
				if(val) {
					window.scrollTo({ top: 250, behavior: 'smooth' });
				}
			}
		},
		components: {
			LoadingSpinner : () => import('GroomyRoot/components/Logos/LoadingSpinner_35'),
		}
	}
</script>
